import React from 'react';

import BdsLabelPill from '../../../shared/components/v3/BdsLabelPill/BdsLabelPill';
import BdsIconButton from '../../../shared/components/v3/Buttons/BdsIconButton/BdsIconButton';
import { ARROW_LEFT_ICON } from '../../../shared/constants/images';
import { useScrollState } from '../../../shared/hooks/useScrollState/useScrollState';
import { GenericVoidFunction } from '../../../shared/types/genericTypes';
import { BdsLabelPillVariant } from '../../../shared/types/types';

import './DetailHeader.scss';

interface IDetailHeader {
  title: string;
  subtitle?: string;
  tag?: string;
  tagVariant?: BdsLabelPillVariant;
  tagColor?: string;
  backAction?: GenericVoidFunction;
  inverse?: boolean;
}

const DetailHeader = ({
  title,
  subtitle,
  tag,
  tagVariant = 'accent',
  tagColor = 'accent-primary',
  inverse = false,
  backAction
}: IDetailHeader) => {
  const isScrolled = useScrollState(0);
  const headerClass = isScrolled ? 'collapsed' : 'extended';
  const inverseClass = inverse ? 'inverse' : '';

  return (
    <>
      <header className={`detail-header ${headerClass} ${inverseClass}`} data-experience="new">
        <div className={`dh-content ${headerClass}`}>
          {backAction && (
            <div className="back-button">
              <BdsIconButton
                action={backAction}
                size="sm"
                icon={ARROW_LEFT_ICON}
                variant={inverse ? 'transparent' : 'transparent-inverse'}
              />
            </div>
          )}
          <div className="header-text-container gap-6">
            <div className="flex flex-col gap-2">
              {!isScrolled && tag && <BdsLabelPill text={tag ?? ''} variant={tagVariant} color={tagColor} />}
              <div className={`dh-title ${headerClass} ${inverseClass}`}>{title}</div>
            </div>
            {!isScrolled && subtitle && <p className={`dh-subtitle ${inverseClass}`}>{subtitle}</p>}
          </div>
        </div>
      </header>
      {isScrolled && <div className="dh-spacer" />}
    </>
  );
};

export default DetailHeader;
